import { toast } from "sonner";
import { Copy } from "@phosphor-icons/react";

export const EmployeeHeader = ({ emp, balances, showDelete, onResetPassword, onDelete }) => (
  <div className="bg-white border border-stone-200 rounded-lg p-6 flex flex-wrap items-center gap-4 justify-between">
    <div>
      <h1 className="font-heading text-2xl font-extrabold">{emp.name}</h1>
      <p className="text-sm text-stone-500">{emp.designation} · {emp.department} · {emp.employee_code}</p>
    </div>
    <div className="flex items-center gap-4">
      <div className="flex gap-4 text-sm">
        {balances.map((b) => (
          <div key={b.leave_type} className="text-center">
            <div className="font-heading font-extrabold text-lg tabular-nums">{b.balance}</div>
            <div className="text-xs text-stone-500">{b.leave_type}</div>
          </div>
        ))}
      </div>
      <button onClick={onResetPassword} data-testid="reset-password-button"
        className="tap-scale px-4 py-2.5 rounded-full bg-white border border-stone-300 text-stone-700 text-xs font-bold hover:bg-stone-50 transition-colors duration-200">Reset password</button>
      {showDelete && (
        <button onClick={onDelete} data-testid="delete-employee-button"
          className="tap-scale px-4 py-2.5 rounded-full bg-white border border-red-300 text-red-600 text-xs font-bold hover:bg-red-50 transition-colors duration-200">Delete</button>
      )}
    </div>
  </div>
);

export const TempPasswordBanner = ({ tempPw, name }) => {
  if (!tempPw) return null;
  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 flex flex-wrap items-center justify-between gap-3" data-testid="temp-password-banner">
      <div className="text-sm text-amber-900">
        <span className="font-bold">Temporary password:</span>{" "}
        <code className="font-mono font-bold bg-white px-2 py-0.5 rounded border border-amber-200" data-testid="temp-password-value">{tempPw}</code>
        <div className="text-xs text-amber-700 mt-1">Share it securely — {name} must set a new password at first login. It won't be shown again.</div>
      </div>
      <button onClick={() => { navigator.clipboard.writeText(tempPw); toast.success("Copied"); }} data-testid="copy-temp-password"
        className="tap-scale flex items-center gap-1.5 px-4 py-2 rounded-full bg-amber-600 text-white text-xs font-bold hover:bg-amber-700 transition-colors duration-200">
        <Copy size={14} /> Copy
      </button>
    </div>
  );
};
